import React, { memo } from "react";
// utils
import { isEmpty, extractImageConfigFromString } from "@swiggy-private/core-ui";
import { replaceText } from "@swiggy-private/core-ui";
// styles
import { BannerContainer, DeliveryImage, DeliveryTextContainer, DeliveryTextBody } from "./styles";
// constants
import { DELIVERY_SPEED_WIDGET_TEST_IDS as IDS } from "@swiggy-private/cart-test-ids";

export interface DeliveryOptionAsBannerProps {
    // "[[10 mins delivery]] on your {{img|30px|13px|portal/m/bolticon.png}} order"
    deliverySpeedOnlyPresentation?: string;
    // "{{img|200px|180px|portal/m/bolt/bolt-large-delivery-guy.png}}"
    deliverySpeedOnlyPresentationIcon?: string;
    slaCommsText?: string;
}

const DeliveryOptionAsBanner = ({
    deliverySpeedOnlyPresentation = "",
    deliverySpeedOnlyPresentationIcon = "",
    slaCommsText = "",
}: DeliveryOptionAsBannerProps) => {
    // if the deliverySpeedOnlyPresentation or deliverySpeedOnlyPresentationIcon is empty, don't render the component
    if (isEmpty(deliverySpeedOnlyPresentation) || isEmpty(deliverySpeedOnlyPresentationIcon)) {
        return null;
    }

    const isSlaCommsTextPresent = !isEmpty(slaCommsText);
    // extract the height and width from the deliverySpeedOnlyPresentationIcon
    const { height = "auto", width = "auto" } = extractImageConfigFromString(deliverySpeedOnlyPresentationIcon) || {};

    return (
        <BannerContainer
            isSlaCommsTextPresent={isSlaCommsTextPresent}
            data-testid={IDS.DELIVERY_SPEED_PRESENTATION_BANNER_CONTAINER}
        >
            <DeliveryTextContainer data-testid={IDS.DELIVERY_SPEED_PRESENTATION_BANNER_TEXT}>
                <DeliveryTextBody variant="V2.body3.neutral.medium" color="text_Highest_Emphasis">
                    {replaceText(deliverySpeedOnlyPresentation, "", true)}
                </DeliveryTextBody>
            </DeliveryTextContainer>
            <DeliveryImage
                imgContainerHeight={height}
                imgContainerWidth={width}
                data-testid={IDS.DELIVERY_SPEED_PRESENTATION_BANNER_IMAGE}
            >
                {replaceText(deliverySpeedOnlyPresentationIcon, "", true)}
            </DeliveryImage>
        </BannerContainer>
    );
};

export default memo(DeliveryOptionAsBanner);
